<!-- Header -->
<section class="card">
  <div class="card-header card-header-grid">
    <!-- Search -->
    <div class="input-group input-lined" role="search">
      <div class="input-group-text">
        <i role="img" class="fa fa-search text-muted" aria-hidden="true"></i>
      </div>
      <input
        class="form-control"
        type="search"
        placeholder="{{ 'general.search' | translate }}"
        attr.aria-label="{{ 'general.search' | translate }}"
        [(ngModel)]="filterTerm"
        (ngModelChange)="onSearch($event)"
      />
    </div>
    <!-- End Search -->

    <div class="d-flex justify-content-end align-items-center">
      <div class="d-flex">
        <total-table-counter
          *ngIf="showTotal"
          [page]="activePage"
          [limit]="limitPage"
          [total]="total"
        ></total-table-counter>
      </div>

      <div
        class="btn-group ms-3"
        dropdown
        *ngIf="bulkActions?.length"
        [canSee]="[accessRights.SerieProposal_delete]"
      >
        <button
          class="btn btn-sm btn-white dropdown-toggle"
          type="button"
          aria-controls="bulkAction"
          dropdownToggle
        >
          {{ 'general.bulkActions' | translate }}
        </button>

        <ul
          *dropdownMenu
          class="dropdown-menu dropdown-menu-right"
          role="menu"
          id="bulkAction"
        >
          <li *ngFor="let bulkAction of bulkActions">
            <a
              class="dropdown-item"
              href="javascript:;"
              (click)="onClickBulkAction(bulkAction)"
            >
              {{ 'general.' + bulkAction | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- End Row -->
  </div>
  <!-- End Header -->

  <!-- Table -->
  <div class="table-responsive">
    <table
      class="table table-borderless table-striped table-hover table-nowrap"
      [mfData]="tableData"
      [mfSortBy]="field"
      [mfSortOrder]="sorted"
      #dataTable="mfDataTable"
      [mfRowsOnPage]="limitPage"
    >
      <thead class="table-light">
        <tr>
          <th
            scope="col"
            *ngIf="bulkActions?.length"
            style="max-width: 60px"
            (click)="onToggleAllChecked()"
            class="cursor-pointer"
          >
            <input
              [checked]="allCheckedToggle"
              type="checkbox"
              class="form-check-input"
              attr.aria-label="{{ 'general.selectAll' | translate }}"
            />
          </th>

          <th scope="col" style="width: 5%">
            <mfDefaultSorter by="id" (click)="onSortfieldClick('id')">
              {{ 'general.id' | translate }}

              <i
                class="fa ms-1"
                role="img"
                [ngClass]="{
                  'fa-sort-down': sortingField == 'id_desc',
                  'fa-sort-up ': sortingField == 'id_asc',
                  'fa-sort text-muted  opacity-50':
                    sortingField !== 'id_asc' && sortingField !== 'id_desc'
                }"
                attr.aria-label="{{ 'wcag.sort' | translate }}"
              >
              </i>
            </mfDefaultSorter>
          </th>
          <th scope="col" style="width: 10%">
            <mfDefaultSorter by="type" (click)="onSortfieldClick('type')">
              {{ 'general.type' | translate }}

              <i
                class="fa ms-1"
                role="img"
                [ngClass]="{
                  'fa-sort-down': sortingField == 'type_desc',
                  'fa-sort-up ': sortingField == 'type_asc',
                  'fa-sort text-muted  opacity-50':
                    sortingField !== 'type_asc' && sortingField !== 'type_desc'
                }"
                attr.aria-label="{{ 'wcag.sort' | translate }}"
              >
              </i>
            </mfDefaultSorter>
          </th>
          <th scope="col" style="width: 15%">
            <mfDefaultSorter
              by="startDate"
              (click)="onSortfieldClick('startDate')"
            >
              {{ 'general.date' | translate }}

              <i
                class="fa ms-1"
                role="img"
                [ngClass]="{
                  'fa-sort-down': sortingField == 'startDate_desc',
                  'fa-sort-up ': sortingField == 'startDate_asc',
                  'fa-sort text-muted  opacity-50':
                    sortingField !== 'startDate_asc' &&
                    sortingField !== 'startDate_desc'
                }"
                attr.aria-label="{{ 'wcag.sort' | translate }}"
              >
              </i>
            </mfDefaultSorter>
          </th>
          <th scope="col" style="width: 10%">
            {{ 'general.day' | translate }}
          </th>

          <th scope="col" style="width: 10%">
            <mfDefaultSorter
              by="productId"
              (click)="onSortfieldClick('productId')"
            >
              {{ 'productModule.resource' | translate }}

              <i
                class="fa ms-1"
                role="img"
                [ngClass]="{
                  'fa-sort-down': sortingField == 'productId_desc',
                  'fa-sort-up ': sortingField == 'productId_asc',
                  'fa-sort text-muted  opacity-50':
                    sortingField !== 'productId_asc' &&
                    sortingField !== 'productId_desc'
                }"
                attr.aria-label="{{ 'wcag.sort' | translate }}"
              >
              </i>
            </mfDefaultSorter>
          </th>

          <th scope="col" style="width: 15%">
            <mfDefaultSorter
              by="organizationId"
              (click)="onSortfieldClick('organizationId')"
            >
              {{ 'organizationModule.organization' | translate }}

              <i
                class="fa ms-1"
                role="img"
                [ngClass]="{
                  'fa-sort-down': sortingField == 'organizationId_desc',
                  'fa-sort-up ': sortingField == 'organizationId_asc',
                  'fa-sort text-muted  opacity-50':
                    sortingField !== 'organizationId_asc' &&
                    sortingField !== 'organizationId_desc'
                }"
                attr.aria-label="{{ 'wcag.sort' | translate }}"
              >
              </i>
            </mfDefaultSorter>
          </th>

          <th scope="col" style="width: 15%">
            {{ 'serieProposalModule.organizationCategory' | translate }}
          </th>

          <th scope="col" style="width: 10%">
            <mfDefaultSorter by="status" (click)="onSortfieldClick('status')">
              {{ 'general.status' | translate }}

              <i
                class="fa ms-1"
                [ngClass]="{
                  'fa-sort-down': sortingField == 'status_desc',
                  'fa-sort-up ': sortingField == 'status_asc',
                  'fa-sort text-muted  opacity-50':
                    sortingField !== 'status_asc' &&
                    sortingField !== 'status_desc'
                }"
                role="img"
                attr.aria-label="{{ 'wcag.sort' | translate }}"
              >
              </i>
            </mfDefaultSorter>
          </th>

          <th scope="col" style="width: 15%">
            <mfDefaultSorter
              by="customerPersonId"
              (click)="onSortfieldClick('customerPersonId')"
            >
              {{ 'memberModule.member' | translate }}

              <i
                class="fa ms-1"
                role="img"
                [ngClass]="{
                  'fa-sort-down ': sortingField == 'customerPersonId_desc',
                  'fa-sort-up ': sortingField == 'customerPersonId_asc',
                  'fa-sort text-muted  opacity-50':
                    sortingField !== 'customerPersonId_asc' &&
                    sortingField !== 'customerPersonId_desc'
                }"
                attr.aria-label="{{ 'wcag.sort' | translate }}"
              >
              </i>
            </mfDefaultSorter>
          </th>

          <th scope="col" style="width: 15%">
            <mfDefaultSorter
              by="messages"
              (click)="onSortfieldClick('messages')"
            >
              {{ 'general.messages' | translate }}

              <i
                class="fa ms-1"
                role="img"
                [ngClass]="{
                  'fa-sort-down ': sortingField == 'messages_desc',
                  'fa-sort-up ': sortingField == 'messages_asc',
                  'fa-sort text-muted  opacity-50':
                    sortingField !== 'messages_asc' &&
                    sortingField !== 'messages_desc'
                }"
                attr.aria-label="{{ 'wcag.sort' | translate }}"
              >
              </i>
            </mfDefaultSorter>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let item of dataTable.data; let i = index"
          class="cursor-pointer"
        >
          <td
            *ngIf="bulkActions?.length"
            (click)="onCheckRow(item)"
            class="cursor-pointer"
          >
            <input
              [checked]="this.checkedIds.get(item.id)"
              type="checkbox"
              class="form-check-input"
              attr.aria-label="{{ 'wcag.selectThis' | translate }}"
            />
          </td>

          <!-- id -->
          <td
            (click)="onRowClicked(item)"
            (keyup.enter)="onRowClicked(item)"
            tabindex="0"
            role="link"
          >
            {{ item.id }}
          </td>
          <td (click)="onRowClicked(item)">
            <span *ngIf="item.type == serieProposalType.REPEATABLE_BOOKING">
              {{ 'serieProposalModule.serie' | translate }}
            </span>
            <span *ngIf="item.type == serieProposalType.CUSTOM_DATE">
              {{ 'serieProposalModule.custom' | translate }}
            </span>
          </td>
          <!-- date  -->
          <td (click)="onRowClicked(item)">
            {{
              item.startDate
                | date: 'd MMM yyyy' : null : (selectedLanguage$ | async)
            }}
            -
            {{
              item.endDate
                | date: 'd MMM yyyy' : null : (selectedLanguage$ | async)
            }}
          </td>

          <!-- day  -->
          <td (click)="onRowClicked(item)">
            <span *ngIf="item.type == serieProposalType.REPEATABLE_BOOKING">{{
              getDaysText(item) | async
            }}</span>
          </td>

          <!-- resource  -->
          <td (click)="onRowClicked(item)">
            {{
              (item.productId
                | getTranslation: 'product' : 'description'
                | async) ||
                (productEntities$ | async)[item.productId]?.description
            }}
          </td>

          <!-- organization  -->
          <td (click)="onRowClicked(item)">
            {{
              (organizationEntities$ | async)[item.organizationId]?.description
            }}
          </td>

          <!-- organization category  -->
          <td (click)="onRowClicked(item)">
            {{ getCategory$(item) | async | getCategoryDescription | async }}
          </td>

          <!-- status  -->
          <td (click)="onRowClicked(item)">
            <span
              class="badge bg-soft-primary"
              *ngIf="item.status == serieProposalStatus.REQUESTED"
            >
              {{ 'serieProposalModule.requested' | translate }}
            </span>
            <span
              class="badge bg-soft-success"
              *ngIf="item.status == serieProposalStatus.ACCEPTED"
            >
              {{ 'serieProposalModule.accepted' | translate }}
            </span>
            <span
              class="badge bg-soft-warning"
              *ngIf="item.status == serieProposalStatus.COUNTER_PROPOSAL"
            >
              {{
                getSerieProposalCounterProposalText(item) | async | translate
              }}
            </span>
            <span
              class="badge bg-soft-danger"
              *ngIf="item.status == serieProposalStatus.DECLINED"
            >
              {{ 'serieProposalModule.declined' | translate }}
            </span>
          </td>

          <!-- member  -->
          <td (click)="onRowClicked(item)">
            {{ (memberEntities$ | async)[item.customerPersonId]?.firstName }}
            {{ (memberEntities$ | async)[item.customerPersonId]?.lastName }}
          </td>

          <!-- message  -->
          <td
            (click)="onMessageClicked(item)"
            (keyup.enter)="onMessageClicked(item)"
            tabindex="0"
            role="button"
          >
            {{ item.messages?.length ? item.messages?.length : '' }}

            <span
              *ngIf="messageService.hasNewMessage(item)"
              class="badge bg-primary ms-2"
            >
              {{ 'general.new' | translate }}
            </span>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="10" class="pb-0">
            <table-footer
              class=""
              #footer
              [activePage]="activePage - 1"
              [limitOnPage]="limitPage"
              [totalPages]="pageCount"
              (selectedPage)="selectPage($event)"
              (searchLimit)="setSearchLimit($event)"
            >
            </table-footer>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</section>
